import { useEffect } from "react";
import { ApplicationHeader, Instructions } from "@/components/application/ApplicationSection";
import { ApplicationForm } from "@/components/application/ApplicationForm";

export default function BlankApplication() {
  useEffect(() => {
    document.title = "Blank Staffing Employment Application — Elevion Care Network LLC";
    const t = setTimeout(() => window.print(), 900);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="bg-[#FBF8F1] min-h-screen font-sans print-blank" data-testid="blank-application-page">
      <div className="max-w-4xl mx-auto py-8 px-4">
        <div className="no-print mb-4 flex flex-wrap gap-3 items-center justify-between">
          <p className="text-sm text-[#465F57]">Your print dialog opens automatically. Choose "Save as PDF" to download.</p>
          <button type="button" onClick={() => window.print()} className="btn-primary" data-testid="blank-print-btn">Print / Save PDF</button>
        </div>
        <div className="bg-[#FBF8F1] rounded-3xl border border-[#154F49]/20 overflow-hidden">
          <ApplicationHeader />
          <Instructions />
          <ApplicationForm blank />
        </div>
      </div>
    </div>
  );
}
